
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';

import ObjectInfoTitle from '../ObjectInfoTitle';
import IfComp from '../IfComp';
import MapDialog from '../../map/MapDialog';
import IsknParInfo from './IsknParInfo';
import IsknVlaList from './IsknVlaList';
import ParHistoryDialog from './ParHistoryDialog';

const IsknParObject = ({isknDate, objectInfo}) => {

    const par = objectInfo.par[0];

    const handleShowHistory = async () => {
        const dialog = ParHistoryDialog();
        await dialog.open(par.par_id);
    }

    const handleShowInMap = async () => {
        const dialog = MapDialog();
        await dialog.open(par);
    }

    return (
        <Stack tokens={{childrenGap: 16}}>
            <Stack.Item>
                <ObjectInfoTitle title="PARCELA" />
                <IsknParInfo
                    data={objectInfo}
                    isknDate={isknDate}
                />
            </Stack.Item>
            <Stack.Item>
                <ObjectInfoTitle title="VLASTNÍCI" />
                <IsknVlaList
                    data={objectInfo}
                    isknDate={isknDate}
                />
            </Stack.Item>
            <Stack.Item>
                <Stack horizontal tokens={{childrenGap: 8}}>
                    <DefaultButton onClick={handleShowHistory} text="Zobrazit historii" />
                    <IfComp cond={!!par.souradnice_x && !!par.souradnice_y}>
                        <Stack.Item>
                            <DefaultButton onClick={handleShowInMap} text="Zobrazit v mapě" />
                        </Stack.Item>
                    </IfComp>
                </Stack>
            </Stack.Item>

        </Stack>
    );
}

export default IsknParObject;
